import generateId from '@/utils/generateId'

export default function useFileToExchangeResource({
  file,
  id = '',
  category,
  isZip = false,
  isImageLanguagePackage = false,
  isModel = false,
  isCocosModel = false,
  modelLanguage = '',
  tagIds = '',
  extra = {},
}: any): any {
  const isAssetRes = file.res_source === 'assets'
  const isCommonRes = file.res_source === 'common'
  const newExtra = {
    ...extra,
    // 更新原始资源链接
    origin_file_url: file.url,
  }
  if (file.resolution) {
    const resolution = file.resolution
      .split('x')
      .map((item: string) => Number(item))
    newExtra.width = resolution[0]
    newExtra.height = resolution[1]
  }
  const newResource: any = {
    extra: newExtra,
    file_name: file.origin_name,
    prefix: category.prefix,
    resource_type: category.resource_type,
    file_path: file.file_path,
    file_url: file.url || '',
    id: id || 'fe_id:' + generateId(),
    resource_origin: 'local',
    file_md5: file.md5,
    isRepository: category.isRepository,
    isModel: isModel,
    isCocosModel: isCocosModel,
    category_id: category.id,
  }
  // 如果是 zip 包，则需要把 zip 包中的文件名作为资源名称
  if (isZip && (Array.isArray(file.files) || file.convertFiles)) {
    // 如果是 model ，只需要把 lm 和 txtUrl（如有） 放在 preview_urls 中，另外需要把 fbx 文件放在 extra 属性的 origin_file_url 中
    if (isModel) {
      if (file.files) {
        const fbxUrlName = file.files.find((item: any) =>
          item.toLocaleLowerCase().endsWith('.fbx'),
        )
        newResource.extra.origin_file_url = `${file.url}/${fbxUrlName}`
        newResource.preview_urls = file.files
          .filter((item: string) => !item.toLocaleLowerCase().endsWith('.fbx'))
          .map((item: string) => `${file.url}/${item}`)
      } else {
        newResource.preview_urls = []
      }
      // cocos模型需要拼接转换接口返回文件列表
      if (isCocosModel) {
        newResource.preview_urls = newResource.preview_urls.concat(
          file.convertFiles || [],
        )
      }
    } else {
      newResource.preview_urls = file.files.map(
        (item: string) => `${file.url}/${item}`,
      )
    }
  }
  if (isImageLanguagePackage && modelLanguage) {
    newResource.zip_sign = modelLanguage
  }
  if (category.isNeedToAddTag && tagIds) {
    newResource.res_tag_ids = tagIds.join(',')
  }
  if (isAssetRes || isCommonRes) {
    newResource.res_id = file.res_id
    newResource.res_source = file.res_source
  }
  console.log('newResource', newResource)
  return newResource
}
